module.exports = __webpack_public_path__ + "img/55.10.pH.72b36b5e.png";